import {FC, MouseEventHandler} from 'react';
import clsx from 'clsx';
import Button from 'components/Button';
import BooleanGroupValue from './BooleanGroupValue';
import BooleanValue from './BooleanValue';
import CurrencyValue from './CurrencyValue';
import DateValue from './DateValue';
import NumberValue from './NumberValue';
import StringValue from './StringValue';
import TagsValue from './TagsValue';
import type {
    BooleanGroupValueType,
    BooleanValueType,
    CurrencyValueType,
    DateValueType,
    NumberValueType,
    StringValueType,
    TagsValueType,
    ValueType,
} from './types';

export type ValueProps = {
    className?: string;
    onEdit?: MouseEventHandler;
    value: ValueType;
};

const Value: FC<ValueProps> = ({className, onEdit, value}) => {
    const {type, ...props} = value;
    let component;

    if (type === 'boolean') {
        component = <BooleanValue {...(props as BooleanValueType)} />;
    } else if (type === 'boolean-group') {
        component = <BooleanGroupValue {...(props as BooleanGroupValueType)} />;
    } else if (type === 'currency') {
        component = <CurrencyValue {...(props as CurrencyValueType)} />;
    } else if (type === 'date') {
        component = <DateValue {...(props as DateValueType)} />;
    } else if (type === 'number') {
        component = <NumberValue {...(props as NumberValueType)} />;
    } else if (type === 'string') {
        component = <StringValue {...(props as StringValueType)} />;
    } else if (type === 'tags') {
        component = <TagsValue {...(props as TagsValueType)} />;
    } else {
        throw new Error(`UNKNOWN VALUE TYPE: ${type}`);
    }

    return (
        <div className={clsx('flex', className)}>
            <div className="flex-1 min-w-0">{component}</div>
            {onEdit && (
                <div className="ml-3 flex-none">
                    <Button kind="secondary" onClick={onEdit} size="xs">
                        Edit
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Value;
